/**
 *  default prefix "NAVIGATION_PANEL"
 */
export const AT_NAVIGATION_PANEL_IS_OPEN_SET = 'NAVIGATION_PANEL_IS_OPEN_SET';
export const AT_NAVIGATION_PANEL_TYPE_SET = 'NAVIGATION_PANEL_TYPE_SET';
export const AT_NAVIGATION_PANEL_IS_ASIDE_OPEN_SET = 'NAVIGATION_PANEL_IS_ASIDE_OPEN_SET';
export const AT_NAVIGATION_PANEL_QUICK_START_GUIDE_SET = 'NAVIGATION_PANEL_QUICK_START_GUIDE_SET';
